// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3VZkm","footer":"ModalUpdate_footer__29H_7"};